// extracted by mini-css-extract-plugin
export default {"colorPicker":"Colorpicker_colorPicker__xdVo9","themeA":"Colorpicker_themeA__Y8K73","themeB":"Colorpicker_themeB__+HmZF","themeC":"Colorpicker_themeC__W3i1o"};